import { Checkbox, FormControl, FormControlLabel, FormHelperText, Typography } from "@mui/material"
import { DebugBox } from "@northpowerdev/np-react-utils"
import { useState } from "react"
import { Controller } from "react-hook-form"

/**
 * @param {object} props
 * @param {String} props.fieldName useForm required part of defaultFormValues e.g 'requestedInformationTypeList'
 * @param {String} props.fieldLabel label shown at top of the component
 * @param {object} props.control as returned by useForm
 * @param {object} props.errors as returned by useForm
 * @param {object} props.options E.g [{value: 'one', label: 'Number One'}, ...] 
 * @param {object|function} props.rules defaults to {required: true}
 * @param {String} props.checkboxHelperText 'Select one or multiple options'
 * @param {object} props.controlSx mui Styling for FormControl
 * @returns JSX
 */
export function MultiSelectCheckbox({ fieldName, fieldLabel = '', control, errors, options, rules = { required: true }, checkboxHelperText, controlSx = {} }) {

    return (
        <CheckboxLabels control={control} errors={errors} options={options} fieldName={fieldName}
            fieldLabel={fieldLabel} rules={rules} checkboxHelperText={checkboxHelperText}
            controlSx={controlSx}
        />
    )
}

/**
 * @param {object} props
 * @param {String} props.fieldName 
 * @param {String} props.fieldLabel 
 * @param {object} props.control as returned by useForm
 * @param {object} props.errors as returned by useForm
 * @param {object} props.options E.g [{value: 'one', label: 'Number One'}, ...] 
 * @param {object|function} props.rules rules as required by react hooks form Controller
 * @param {String} props.checkboxHelperText 'Select one or multiple options'
 * @param {object} props.controlSx mui Styling for FormControl
 * @returns JSX
 */
export function CheckboxLabels({ fieldName, fieldLabel, control, errors, options, rules, checkboxHelperText, controlSx }) {
    const [checkedItems, setCheckedItems] = useState([])

    const addItem = (item) => {
        console.log("append checked item")
        const itemAppendedToCheckedItems = [...new Set([...checkedItems, item])]
        return itemAppendedToCheckedItems
    }
    const removeItem = (item) => {
        console.log("removing checked item")
        const filterItems = checkedItems.filter((i) => i !== item)
        return filterItems
    }

    return (
        <>
            <FormControl sx={{ ...controlSx }} error={!!errors[fieldName]}>
                <Controller
                    name={fieldName}
                    control={control}
                    rules={rules}
                    render={({ field, fieldState }) => (
                        <>
                            <Typography variant="body1" sx={(!!errors[fieldName]) ? { color: '#d32f2f' } : null} >{fieldLabel}</Typography>
                            {options?.map((item, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox

                                            onChange={(e) => {
                                                let changedItems
                                                if (e.target.checked) {
                                                    changedItems = addItem(item.value)
                                                    console.log("item added", changedItems)
                                                } else {
                                                    changedItems = removeItem(item.value)
                                                    console.log("remove item: ", changedItems)
                                                }
                                                setCheckedItems(changedItems)
                                                field.onChange(changedItems)
                                            }}
                                        />
                                    }
                                    label={item.label}
                                />
                            ))}
                            {
                                (!!errors[fieldName])
                                &&
                                <FormHelperText sx={{ m: 0 }}>{fieldState?.error?.message || checkboxHelperText}</FormHelperText>
                            }
                        </>

                    )}
                />

            </FormControl>

            {/* //debug */}
            <DebugBox title='checked items' stringify>{checkedItems}</DebugBox>
        </>
    )
}